import { HideInfobarDetailsButton } from 'owa-locstrings/lib/strings/hideinfobardetailsbutton.locstring.json';
import { ShowInfobarDetailsButton } from 'owa-locstrings/lib/strings/showinfobardetailsbutton.locstring.json';
import loc from 'owa-localize';
/* tslint:disable:jsx-no-lambda WI:47750 */
import * as React from 'react';
import getLargeAudienceMailtipInfoText from '../utils/getLargeAudienceMailtipInfoText';

import LargeAudienceDetails, { RecipientMailtipInfoWithMembersCount } from './LargeAudienceDetails';
import MultiRecipientMailtip from './MultiRecipientMailtip';
import { InfoBarMessagePart } from 'owa-info-bar-view';
import type EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import type ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { MailTipsCategory } from '../datapoints';

export interface LargeAudienceMailtipProps {
    approximateMemberLimit?: number;
    colorScheme?: ColorScheme;
    extraLargeMemberLimit?: number;
    onRemoveRecipientClick: (recipient: EmailAddressWrapper) => void;
    recipientsInfo: RecipientMailtipInfoWithMembersCount[];
}

/**
 * extraLargeMemberLimit: default value 1000(from JSMVVM) which decides header text string in this mailtip
 * approximateMemberLimit: default value 100(from JSMVVM) which decides header text string and submessage string in this mailtip
 */
const LargeAudienceMailtip = ({
    onRemoveRecipientClick,
    recipientsInfo,
    extraLargeMemberLimit = 1000,
    approximateMemberLimit = 100,
    colorScheme,
}: LargeAudienceMailtipProps): JSX.Element => {
    return (
        <MultiRecipientMailtip
            colorScheme={colorScheme}
            messageInfoElement={
                <InfoBarMessagePart
                    colorScheme={colorScheme}
                    messagePart={getLargeAudienceMailtipInfoText(
                        approximateMemberLimit,
                        recipientsInfo,
                        extraLargeMemberLimit
                    )}
                />
            }
            showHideDetails={{
                showDetailsText: loc(ShowInfobarDetailsButton),
                hideDetailsText: loc(HideInfobarDetailsButton),
                detailsElement: null,
            }}
            detailsRenderer={() => (
                <LargeAudienceDetails
                    colorScheme={colorScheme}
                    recipientsInfo={recipientsInfo}
                    onRecipientRemoveClick={onRemoveRecipientClick}
                    approximateMemberLimit={approximateMemberLimit}
                />
            )}
            mailTipsCategory={MailTipsCategory.LargeAudience}
            recipientCount={recipientsInfo.length}
        />
    );
};

export default LargeAudienceMailtip;
